var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitebit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4884E8",
    d: "m834.8 286.1 176.6-176.6H794.6c-84.3 0-144.8 43.4-167.4 114.9-5.3 16.8-6.7 39-5.3 61.7H405l176.6-176.6H367.3c-97.5 0-176.6 79.1-176.6 176.6h-1.3c-97.5 0-176.6 79.1-176.6 176.6h177.9v133.1c0 176.4 143.2 319.3 319.6 318.9h324.5V286.1M598.9 588.5a88.78 88.78 0 0 1 0-125.6l125.6 125.6a88.96 88.96 0 0 1-125.6 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitebit2);
export default __webpack_public_path__ + "static/media/whitebit2.8fcfbd38.svg";
export { ForwardRef as ReactComponent };